// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"83dbf0e6","466":"2d87851e"}[chunkId] + ".chunk.css";
};